export { LoginPage as default } from '../../components-v2/auth/AuthPages';
